import {
  GET_BOOKMARK_LIST,
  IS_LOADING,
  TOP_TEN_LIKED_BOOKMARKS,
  GET_ACTIVE_BOOKMARK_SITES
} from "./homePageActionsTypes";

const INITIAL_STATE = {
  bookmarkLists: "",
  totalBookmarks: 0,
  isLoading: false,
  topTenLikedBookmarks: [],
  totalTopTenLikedBookmarks: 0,
  activeBookmarkSites: [],
  totalActiveBookmarkSites: 0
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_BOOKMARK_LIST:
      return {
        ...state,
        bookmarkLists: action.payload.data.result,
        totalBookmarks: action.payload.total
      };
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload
      };
    case TOP_TEN_LIKED_BOOKMARKS:
      return {
        ...state,
        topTenLikedBookmarks: action.payload.data,
        totalTopTenLikedBookmarks: action.payload.total
      };
    case GET_ACTIVE_BOOKMARK_SITES:
      return {
        ...state,
        activeBookmarkSites: action.payload.data,
        totalActiveBookmarkSites: action.payload.total
      };
    default:
      return state;
  }
};
